import { observable, action } from 'mobx'

export default class TermsDialogState {
  @observable showing = false

  @action show () {
    if (this.accepted) {
      return Promise.resolve(true)
    }

    this.showing = true
    return new Promise((resolve) => {
      this.resolve = resolve
    })
  }

  @action decline () {
    this.resolve(false)
    this.showing = false
  }

  @action accept () {
    this.accepted = true
    this.resolve(true)
    this.showing = false
  }
}



// WEBPACK FOOTER //
// ./src/client/components/TermsDialog/TermsDialogState.js